import MetaAttrib from '@/generated/classes/MetaAttrib';
import { MetaValue as MetaValueBase } from '@/generated/classes/MetaAttrib';
import { MetaTag as MetaTagBase } from '@/generated/classes/MetaAttrib';
export default class MetaAttribExtend extends MetaAttrib {
  constructor() {
    super();
  }
}
export class MetaValue extends MetaValueBase {
  constructor() {
    super();
  }
}
export class MetaTag extends MetaTagBase {
  constructor() {
    super();
  }
}
